import type { ReactNode } from "react";
import { Box, FormLabel, Typography } from "@mui/joy";

/** Side-by-side label + control row (label left on desktop, stacked on mobile). */
export function FormRow({
    label,
    description,
    children,
}: {
    label: string;
    description?: string;
    children: ReactNode;
}) {
    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "stretch", md: "center" },
                gap: { xs: 0.5, md: 2 },
            }}
        >
            <Box sx={{ flexBasis: { md: 300 }, flexShrink: 0 }}>
                <FormLabel sx={{ m: 0 }}>{label}</FormLabel>
                {description && (
                    <Typography level="body-xs" sx={{ color: "text.tertiary", mt: 0.25 }}>
                        {description}
                    </Typography>
                )}
            </Box>
            <Box sx={{ flex: 1 }}>{children}</Box>
        </Box>
    );
}
